import SkeletonBlogList from "@modules/skeleton/blog_list";
import BlogRecentPost from "@modules/study/blog/components/recent_post";
import { SocialLinks } from "@modules/study/common/social_links";
import PaginationComponent from "@unisearch/common/ui_element/pagination";
import { getAssets } from "@unisearch/helpers";
import Image from "next/legacy/image";
import Link from "next/link";
import { Fragment, useEffect, useState } from "react";
import BlogListBox from "../components/blog_list_box";
import BlogSearchBox from "../components/blog_search_box";
import styles from "./blog_list.module.scss";
import API from "@unisearch/helpers/api";
import Advertisement from "@unisearch/common/advertisement";
import { useRouter } from "next/router";

export const BlogList = ({
  loading,
  error,
  loadingList,
  blogList,
  handlePager,
  paginate,
}) => {
  const [tags, setTags] = useState([]);

  const router = useRouter();
  const catSlug = router?.query?.blog_cat_slug;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const tagApi = `public/blog-page/blog-tag?`;
        const resp = await API.get(tagApi);
        setTags(resp.data);
      } catch (error) {}
    };

    fetchData();
  }, []);
  const paginationHandler = (_, page) => {
    if (handlePager) {
      handlePager(page);
    }
  };

  let content;
  if (loadingList) {
    content = (
      <div>
        <SkeletonBlogList />
      </div>
    );
  }
  if (!loadingList && error) {
    content = <div>{error}</div>;
  }
  if (!loadingList && !error) {
    content = (
      <Fragment>
        {blogList?.length > 0 ? (
          <>
            <div className={styles.blog_list_box_wrapper}>
              {blogList?.map((post, i) => {
                return (
                  <BlogListBox
                    blogTitle={post?.title}
                    blogLink={`/blog/${post?.slug}`}
                    categoryTitle={post?.category?.title}
                    categories={post?.categories}
                    calegoryLink={`/blog/category/${post?.category?.slug}`}
                    featureImage={
                      post?.posterImage?.src || post?.featureImage?.src
                    }
                    blogContent={post?.content}
                    key={i}
                    videoType={post?.videoType}
                  />
                );
              })}

              <>
                {paginate && paginate.total > parseInt(paginate.limit) && (
                  <PaginationComponent
                    paginate={paginate}
                    paginationHandler={paginationHandler}
                  />
                )}
              </>
            </div>
          </>
        ) : (
          <div>
            <Image
              layout="responsive"
              width={1080}
              height={688}
              blurDataURL={getAssets(
                "assets/images/image_placeholder_big.webp"
              )}
              placeholder="blur"
              src={getAssets("assets/images/no-data-found.webp")}
              alt="blog banner"
            />
          </div>
        )}
      </Fragment>
    );
  }

  // show ad conditionally
  const ShowAddvertisement = () => {
    if (catSlug === "study-in-uk" || catSlug === "study-in-the-uk") {
      return (
        <Advertisement
          width={336}
          height={280}
          src="/ad/study-in-uk-mobile.webp"
          url="https://myunisearch.com/lead/study-in-the-uk"
          className="mt-[30px]"
        />
      );
    } else if (catSlug === "study-in-usa" || catSlug === "study-in-the-usa") {
      return (
        <Advertisement
          width={336}
          height={280}
          src="/ad/study-in-usa-mobile.webp"
          url="https://myunisearch.com/lead/apply-for-scholarships-at-the-university-of-arizona"
          className="mt-[30px]"
        />
      );
    } else if (catSlug === "study-in-australia") {
      return (
        <Advertisement
          width={336}
          height={280}
          src="/ad/study-in-au-mobile.webp"
          url="https://myunisearch.com/lead/apply-for-scholarships-at-the-victoria-university"
          className="mt-[30px]"
        />
      );
    } else if (catSlug === "study-in-canada") {
      return (
        <Advertisement
          width={336}
          height={280}
          src="/ad/study-in-canada-mobile.webp"
          url="https://myunisearch.com/lead/study-in-canada"
          className="mt-[30px]"
        />
      );
    } else if (catSlug === "study-in-ireland") {
      return (
        <Advertisement
          width={336}
          height={280}
          src="/ad/study-in-ireland-mobile.webp"
          url="#"
          className="mt-[30px]"
        />
      );
    } else if (catSlug === "study-in-new-zealand") {
      return (
        <Advertisement
          width={336}
          height={280}
          src="/ad/study-in-new-zealand-mobile.webp"
          url="#"
          className="mt-[30px]"
        />
      );
    } else {
      return (
        <Advertisement
          width={336}
          height={280}
          src="/ad/study-in-au-mobile.webp"
          url="https://myunisearch.com/lead/apply-for-scholarships-at-the-victoria-university"
          className="mt-[30px]"
        />
      );
    }
  };

  return (
    <section className={styles.section_blog_list}>
      <div className="container">
        <div className={styles.wrapper}>
          <div className="grid lg:grid-cols-[2fr_1fr] gap-8">
            {content}
            <div className={styles.aside_wrapper}>
              <BlogSearchBox loading={loading} />

              {/* ad */}
              <ShowAddvertisement />

              {blogList?.length > 0 && <BlogRecentPost />}

              {tags?.length > 0 && (
                <div className={styles.social_links_wrapper}>
                  <h5>Tag</h5>
                  <div className={styles.tag_container}>
                    {tags?.map((item, i) => {
                      return (
                        <Link
                          legacyBehavior
                          href={`/blog/tag/${item.slug}?page=1`}
                          className={styles.tag_link}
                          key={i}
                        >
                          <a>{item?.title}</a>
                        </Link>
                      );
                    })}
                  </div>
                </div>
              )}
              <div className={styles.social_links_wrapper}>
                <h5>Stay in Touch</h5>
                <SocialLinks />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogList;
